
<div class="content-container">
    <mat-card>
      <!-- Privacy Statement should be included here. The Html  document should have it's own title tag. -->
      <mat-card-title>CPCA Calculator</mat-card-title>
      <mat-card-content>
        <app-structure-editor></app-structure-editor>

        <app-nitrosamine-display></app-nitrosamine-display>

      </mat-card-content>
    </mat-card>
  </div>
